import { useCallback, useEffect, useState } from 'react';
import { getServerInfo, numericalPwPluginVersion } from '../plugin';
import { PWServerSupports } from './featureList';
/**
 * Loads ProjectWise server plugin version and returns feature list.
 * @param config - Config to initialize PWServerFeatures
 * @returns PWServerFeatureManager
 */
export function usePWServerFeatures({ datasourceUrl, authorization }) {
    const [initialized, setInitialized] = useState(false);
    const initPWPluginVersion = useCallback(async () => {
        const { pwPluginVersion } = await getServerInfo(datasourceUrl, authorization);
        const pluginVersion = numericalPwPluginVersion(pwPluginVersion);
        PWServerSupports.version = pluginVersion;
        setInitialized(true);
    }, [datasourceUrl, authorization]);
    useEffect(() => {
        setInitialized(false);
        void initPWPluginVersion();
    }, [initPWPluginVersion]);
    return {
        initialized,
        pwServerSupports: PWServerSupports
    };
}
